import styled from "styled-components";
import {GAMING_HISTORY_PAGE, SESSION_HISTORY_PAGE, STICKY} from "../../../themes/css-global-classes";
import {HEADER_Z_INDEX} from "../../header/header-consts";

export const LobbyHeaderDefaultBox = styled.div<{stickOffset: number;}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${props => props.theme.colors.background};
  position: sticky;
  top: ${({stickOffset}) => (stickOffset - 1)+ "px"};
  z-index: ${HEADER_Z_INDEX - 1};

  padding-top: 15px;
  padding-bottom: 12px;
  margin-bottom: 10px;

  &.${STICKY} {
    @media ${({theme}) => theme.mediaQuery.xlAndAbove} {
      background-image: url(${props => props.theme.images.texture.toString()});
    }
  }

  .${GAMING_HISTORY_PAGE} &, .${SESSION_HISTORY_PAGE} &{
      padding-bottom: 0;
  }

  @media ${({theme}) => theme.mediaQuery.lAndBelow} {
    padding-top: 10px;
    padding-bottom: 0;
    margin-bottom: 0;
    &.${STICKY}{
        width:100%;
    }
  }
`;
